enum Operators {
  AND = "and",
  OR = "or",
  LE = "<=",
  L = "<",
  GE = ">=",
  G = ">",
  EQ = "==",
  NE = "!=",
}

const operations: Record<Operators, (x: any, y: any) => any> = {
  [Operators.AND]: (x: any, y: any) => x && y,
  [Operators.OR]: (x: any, y: any) => x || y,
  [Operators.LE]: (x: any, y: any) => x <= y,
  [Operators.L]: (x: any, y: any) => x < y,
  [Operators.GE]: (x: any, y: any) => x >= y,
  [Operators.G]: (x: any, y: any) => x > y,
  [Operators.EQ]: (x: any, y: any) => x == y,
  [Operators.NE]: (x: any, y: any) => x !== y,
};

const isBoolean = (x: string) => x === "false" || x === "true";
const isNumeric = (x: string) =>
  /^[-+]?(\d+(\.\d*)?|\.\d+)([eE][-+]?\d+)?$/.test(x);
const isString = (x: string) =>
  (x.startsWith('"') && x.endsWith('"')) ||
  (x.startsWith("'") && x.endsWith("'"));

export default function naturalEval(
  command: string,
  context: Record<string, number | string | undefined>,
): any {
  const andTokens = command.split(" and ");
  const orTokens = command.split(" or ");

  if (andTokens.length > 1) {
    return andTokens.every((token) => naturalEval(token, context));
  }

  if (orTokens.length > 1) {
    return orTokens.some((token) => naturalEval(token, context));
  }

  const tokens = command.split(" ");

  if (tokens.length === 1) {
    if (isBoolean(command)) {
      return command === "true";
    }

    if (isNumeric(command)) {
      return Number(command);
    }

    if (isString(command)) {
      return command.substring(1, command.length - 1);
    }

    if (command === "null") {
      return null;
    }

    if (command === "undefined") {
      return undefined;
    }

    return context[command];
  }

  for (let i = 0; i < tokens.length; ++i) {
    let operation: Operators | null = null;

    switch (tokens[i]) {
      case Operators.EQ:
        operation = Operators.EQ;
        break;
      case Operators.G:
        operation = Operators.G;
        break;
      case Operators.GE:
        operation = Operators.GE;
        break;
      case Operators.L:
        operation = Operators.L;
        break;
      case Operators.LE:
        operation = Operators.LE;
        break;
      case Operators.NE:
        operation = Operators.NE;
        break;
    }

    if (operation)
      return operations[operation](
        naturalEval(tokens.slice(0, i).join(" "), context),
        naturalEval(tokens.slice(i + 1).join(" "), context),
      );
  }

  return command;
}
